export default class Indicator {
	constructor({name, description, url, team_id, id, company_id, added_on, update_on, team_name}) {
		this.name = name || "";
		this.description = description || "";
		this.url = url || "";
		this.team_id = team_id || 0;
		this.id = id || 0;
		this.company_id = company_id || 0;
		this.added_on = added_on || "";
		this.update_on = update_on || "";
		this.team_name = team_name || "";
	}
}
